import {FaIdCardAlt, FaMobileAlt, FaMoneyBill, FaUser} from 'react-icons/fa';
import {BsFileEarmarkTextFill} from 'react-icons/bs';
import {IoIosWallet} from 'react-icons/io';
import {BsFillGridFill} from 'react-icons/bs';
import {BsFolderSymlinkFill} from 'react-icons/bs';
import {BsFillFilterCircleFill} from 'react-icons/bs';
import {TbReportMoney} from 'react-icons/tb';
import {FaMoneyCheckDollar} from 'react-icons/fa6';

import {PrivatePaths} from '../../routes/path';

export const userLinks = [
  {
    route: PrivatePaths.DASHBOARD,
    name: 'Dashboard',
    Icon: BsFillGridFill,
    allowed: ['Admin', 'SuperAdmin'],
  },

  {
    route: '#',
    name: 'Users',
    Icon: FaUser,
    allowed: ['Admin', 'SuperAdmin'],
    children: [
      {
        route: '/app/account',
        name: 'Accounts',
        Icon: FaUser,
        allowed: ['Admin', 'SuperAdmin'],
      },
      // {
      //   route: "/app/manage/kyc",
      //   name: "Manage KYC",
      //   Icon: FaIdCardAlt,
      //   allowed: ["Admin", "SuperAdmin"],
      // },
    ],
  },
  {
    route: '/app/savings',
    name: 'Savings',
    Icon: IoIosWallet,
    allowed: ['Admin', 'SuperAdmin'],
    children: [
      {
        route: '/app/config/savings',
        name: 'Savings Type',
        Icon: FaIdCardAlt,
        allowed: ['Admin', 'SuperAdmin'],
      },
      {
        route: '/app/savings',
        name: 'Savings',
        Icon: IoIosWallet,
        allowed: ['Admin', 'SuperAdmin'],
      },
    ],
  },
  {
    route: '#',
    name: 'Investments Area',
    Icon: TbReportMoney,
    allowed: ['Admin', 'SuperAdmin'],
    children: [
      {
        route: '/app/investments/sections',
        name: 'Investments',
        Icon: TbReportMoney,
        allowed: ['Admin', 'SuperAdmin'],
      },
    ],
  },
  {
    route: '#',
    name: 'Support',
    Icon: FaMoneyBill,
    allowed: ['Admin', 'SuperAdmin'],
    children: [
      {
        route: '/app/funding',
        name: 'Funding',
        Icon: FaMoneyBill,
        allowed: ['Admin', 'SuperAdmin'],
      },
    ],
  },

  {
    route: '#',
    name: 'TRANSACTIONS',
    Icon: FaIdCardAlt,
    allowed: ['Admin', 'SuperAdmin'],
    children: [
      {
        route: '/app/transactions/history',
        name: 'Transaction History',
        Icon: BsFolderSymlinkFill,
        allowed: ['Admin', 'SuperAdmin'],
      },
      {
        route: '/app/transactions/withdrawal',
        name: 'Withdrawal Request',
        Icon: BsFolderSymlinkFill,
        allowed: ['Admin', 'SuperAdmin'],
      },
    ],
  },
  {
    route: '#',
    name: 'CONFIGURATIONS',
    Icon: FaIdCardAlt,
    allowed: ['Admin', 'SuperAdmin'],
    children: [
      {
        route: '/app/config/admin',
        name: 'Admin',
        Icon: FaIdCardAlt,
        allowed: ['Admin', 'SuperAdmin'],
      },
      {
        route: '/app/config/app-version',
        name: 'App Version',
        Icon: FaMobileAlt,
        allowed: ['Admin', 'SuperAdmin'],
      },
    ],
  },
  {
    route: '#',
    name: 'REPORTS',
    Icon: FaIdCardAlt,
    allowed: ['Admin', 'SuperAdmin'],
    children: [
      {
        route: '/app/activity/report',
        name: 'User Activity',
        Icon: FaIdCardAlt,
        allowed: ['Admin', 'SuperAdmin'],
      },
      // {
      //   route: "/app/driver",
      //   name: "Reports Section",
      //   Icon: FaIdCardAlt,
      //   allowed: ["Admin", "SuperAdmin"],
      // },
    ],
  },
];
